import { translationActions } from "applications/common/actions/translationActions";
import { defaultSagaSuccessHandler, SagaBuilder } from "../../../../framework/sagas/sagaUtilities";
import {
  createGenericSaga,
  defaultSagaErrorHandler
} from "../../../../framework/sagas/sagaUtilities";
import { getApiRegistry } from "../../../../framework/state/apiRegistry";

export const translationSagas = {
  uploadTranslationFile: createGenericSaga(
    "translationSagas/uploadTranslationFile",
    getApiRegistry().translationApi.apiTranslationImportPost.bind(getApiRegistry().translationApi),
    {
      takeEvery: false,
      onSuccess: defaultSagaSuccessHandler("Translation file uploaded successfully"),
      onFail: (request, title, details) => {
        if (details) {
          const errors = Object
            .values(details)
            .filter(array => array.length > 0)
            .map(array => array[0]);

          return new SagaBuilder()
            .dispatch(translationActions.setImportErrors(errors))
            .build()();
        }
        return defaultSagaErrorHandler(request, title, details);
      }
    }
  ),
  getAvailableLanguages: createGenericSaga(
    "translationSagas/getAvailableLanguages",
    getApiRegistry().translationApi.apiTranslationLanguagesGet.bind(
      getApiRegistry().translationApi
    ),
    {
      takeEvery: false,
      onSuccess: undefined,
      onFail: defaultSagaErrorHandler
    }
  ),
  exportTranslationFile: createGenericSaga(
    "translationSagas/exportTranslationFile",
    getApiRegistry().translationApi.apiTranslationExportGetRaw.bind(
      getApiRegistry().translationApi
    ),
    {
      takeEvery: false,
      onSuccess: undefined,
      onFail: defaultSagaErrorHandler
    }
  )
};
